import Gallery from "./Gallery";
import "./home.css";
const Projects = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 pt-10 pb-0">
      <div className="text-center">
        <h1 className="mx-auto sub-heading"> Gallery</h1>
        <h1 className="heading">Pool home care is a well known construction and production firm engaged in developed,
        designing and installation of water...</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
      <div className="gallery">
        <Gallery/>
      </div>
      </div>
    </div>
  );
};

export default Projects;
